import angular from 'angular';

angular.module("core.application.main").filter("core_application_main_filter_paymentType", function() {

    //TODO make this mapper multilanguage

    // convert the backend payment types into the front presentation
    return function (input) {
        if (input === "PAY_NOW") {
            return "general:credit-card";
        } else if (input === "PAD") {
            return "general:try-before";
        } else if (input === "PBI") {
            return "general:pay-over-time";
        }
    };
});
